// src/pages/Tree.js
import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import { Link } from 'react-router-dom';
import '../styles/tree.css';
import TreeFarmComponent from '../components/TreeFarmComponent';
import TreeCatalogSection from '../components/TreeCatalogSection'; 
import { treeCatalog } from '../data/treeCatalog'; 
import CTASection from '../components/CTASection';

const Tree = () => {
  // Flip card helper for touch devices
  const handleFlipCard = (e) => {
    if ('ontouchstart' in window) {
      e.currentTarget.classList.toggle('flipped');
    }
  };

  return (
    <div className="tree-page">
      <Navbar />
      <Breadcrumb />

      {/* Hero Section */}
      <section className="tree-hero">
        <img
          src="/images/tree/treeHeroImage2.png"
          alt="All Seasons Tree Logo"
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="tree-hero-overlay">
          <div className="tree-hero-content">
            <h1 className="tree-hero-title">Transform Your Landscape with Premium Trees</h1>
            <p className="tree-hero-subtitle">
              From our tree farm to your property – mature specimens and young saplings available
            </p>
            <Link to="/Gallery" className="btn-cta">
              View Our Gallery
            </Link>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Your Complete Tree Solution</h2>
          <p className="intro-text">
            All Seasons Landscaping doesn't just plant trees – we cultivate them. With our own
            tree farm in the Wood River Valley, we offer an extensive selection of native and
            adapted trees perfect for Sun Valley's unique climate. Whether you're looking for a
            single statement tree or planning a complete landscape transformation, we provide
            everything from selection to professional installation.
          </p>

          {/* Services Flip Grid */}
          <div className="tree-services-grid">
            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeHeroImage2.png"
                    alt="Tree Selection"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Expert Selection</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Expert Selection</h3>
                    <p>Choose from hundreds of trees at our nursery</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeHeroImage2.png"
                    alt="Delivery"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Professional Delivery</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Professional Delivery</h3>
                    <p>Safe transport of mature specimens up to 30 feet tall</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeInstallation.png"
                    alt="Installation"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Expert Installation</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Expert Installation</h3>
                    <p>Proper planting ensures healthy growth for decades</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="service-flip-card" onClick={handleFlipCard}>
              <div className="flip-card-inner">
                <div className="flip-card-front">
                  <img
                    src="images/tree/treeMaintenance1.jpg"
                    alt="Tree Care"
                    className="service-bg-image"
                  />
                  <h3 className="service-title-overlay">Ongoing Care</h3>
                </div>
                <div className="flip-card-back">
                  <div className="flip-card-content">
                    <h3>Ongoing Care</h3>
                    <p>Pruning, health assessments, and maintenance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>{/* /.tree-services-grid */}
        </div>
      </section>

      {/* Tree Farm Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 id="treefarm-home" className="section-title">Our Tree Farm</h2>
          <TreeFarmComponent variant="compact" headingId="treefarm-home" />
        </div>
      </section>

      {/* Featured Tree Availability — Simple client list via ContentSplitSections */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Featured Tree Availability</h2>
          <p className="section-intro text-center">
            A snapshot of client-requested favorites. Ask us for the full list or a site-specific recommendation.
          </p>
        </div>
      </section>

      {/* Uses your existing ContentSplitSections under the hood via a mapper */}
     <div className="tree-catalog-wrapper">
  <TreeCatalogSection items={treeCatalog.slice(0, 3)} />
  <TreeCatalogSection items={treeCatalog.slice(9, 12)} />
</div>

      {/* Scale & Impact Section */}
      <section className="section bg-evergreen text-white">
        <div className="section-inner text-center">
          <h2 className="section-title">Think Big. Plant Big.</h2>
          <div className="scale-showcase">
            <div className="scale-item">
              <h3>6-8 feet</h3>
              <p>Young trees perfect for new construction</p>
            </div>
            <div className="scale-item featured">
              <h3>15-20 feet</h3>
              <p>Mature specimens for instant impact</p>
            </div>
            <div className="scale-item">
              <h3>25-30+ feet</h3>
              <p>Estate-sized trees for dramatic transformation</p>
            </div>
          </div>
          <p className="scale-text">
            Why wait decades for shade and privacy? Our mature tree inventory allows you to enjoy
            established landscapes immediately. With specialized equipment and expert crews, we can
            safely transplant trees of virtually any size.
          </p>
        </div>
      </section>
       {/* CTA Section */}
  
     <CTASection 
  title="Experience the Difference"
  subtitle="See why landscape professionals and homeowners choose All Seasons Tree Farm for their most important projects"
  galleryLink="/Gallery/treefarm"
  showEmergency={false}
/>
    </div>
  );
};

export default Tree;
